<template>
   <div class="ui-badge-container" :class="{ warning, error, info, small }">
      <Icon name="info-circle" />
      <span>{{ msg }}</span>
   </div>
</template>

<script>
export default {
   name: "UIBadge2",
   props: {
      msg: String,
      warning: Boolean,
      error: Boolean,
      info: Boolean,
      small: Boolean,
   },
};
</script>

<style lang="scss" scoped>
@keyframes badge {
   0% {
      opacity: 1;
   }
   50% {
      opacity: 1;
   }
   100% {
      opacity: 0;
   }
}
.ui-badge-container {
   border-radius: 0.5rem;
   border-style: solid;
   border-width: 1px;
   padding: 0.75rem 1rem;
   display: flex;
   align-items: center;
   gap: 0.5rem;
   animation-timing-function: ease-in-out;
   animation-name: badge;
   animation-duration: 0.5s;
   animation-iteration-count: 3;

   i {
      $infoIcon: 38px !important;
      width: $infoIcon;
      height: $infoIcon;
      filter: brightness(0.25);
      margin-right: 0.75rem;
   }

   span {
      font-weight: 500;
      font-size: var(--large);
      color: var(--gray-800);
   }
   &.small {
      padding: 0.25rem 0.5rem;

      span {
         font-size: var(--normal);
      }
      i {
         $infoIcon: 30px !important;
         width: $infoIcon;
         height: $infoIcon;
      }
   }
   &.warning {
      background-color: var(--yellow-100);
      border-color: var(--yellow-500);

      span {
         color: var(--yellow-800);
      }

      ::v-deep svg path {
         stroke: var(--yellow-800);
      }
   }
   &.error {
      background-color: var(--red-100);
      border-color: var(--red-500);

      span {
         color: var(--red-800);
      }

      ::v-deep svg path {
         stroke: var(--red-800);
      }
   }
   &.info {
      background-color: var(--blue-100);
      border-color: var(--blue-500);

      span {
         color: var(--blue-800);
      }

      ::v-deep svg path {
         stroke: var(--blue-800);
      }
   }
}
</style>
